import React from 'react';
import BaechaList from "../containers/BaechaList/BaechaList";

const BaechaListPage: React.FC = () => <BaechaList />;

export default BaechaListPage;
